<template>
  <div class="fu-drform" data-test="fu-drawer-phone-form">
    <div>
      <label class="fu-drform__label" :for="`${uid}-outcome`">Outcome</label>
      <select
        :id="`${uid}-outcome`"
        class="fu-drform__select"
        :value="String(statusId || 0)"
        data-test="fu-drawer-outcome"
        @change="onStatus($event.target.value)"
      >
        <option value="0" disabled>What happened on the call?</option>
        <option v-for="s in statuses" :key="s.value" :value="String(s.value)">{{ s.label }}</option>
      </select>
      <p v-if="!statuses.length" class="fu-drform__hint">You have not set up statuses yet. Please contact your administrator or contact teamio</p>
    </div>

    <slot />

    <div>
      <label class="fu-drform__label" :for="`${uid}-note`">Commlog note</label>
      <textarea
        :id="`${uid}-note`"
        class="fu-drform__textarea"
        rows="4"
        :value="note"
        placeholder="Add notes about this follow-up..."
        data-test="fu-drawer-note"
        @input="$emit('note-input', $event.target.value)"
      ></textarea>
      <p class="fu-drform__hint fu-drform__hint--copy" data-test="fu-drawer-commlog-hint">
        <fu-icon :name="copiesToCommlog ? 'check' : 'info'" :size="13" />
        {{ copiesToCommlog ? 'Copies to the Open Dental commlog — set in office settings' : 'Not copied to the Open Dental commlog — set in office settings' }}
      </p>
    </div>
  </div>
</template>

<script>
/**
 * DrawerPhoneForm — the Phone method: today's "Follow-up Status" select (the queue's own status list)
 * as the design's "Outcome", the default slot for the next-date control + outcome line, then the
 * commlog note (the container composes it with drawerPayload.composePhoneNote, as today).
 *
 *   statuses         [{ value: FollowupStatusID, label }] — the container maps the status rows
 *                    with the queue's statusLabelField
 *   statusId         the picked id (0 = none)
 *   note             the commlog note
 *   copiesToCommlog  the queue's copy-to-commlog setting is 'TRUE' (today's disabled checkbox)
 * Events: status-change(id: number), note-input(text). Presentational.
 */
import FuIcon from '../FuIcon.vue';

let seq = 0;

export default {
  name: 'DrawerPhoneForm',
  components: { FuIcon },
  props: {
    statuses: { type: Array, default: () => [] },
    statusId: { type: [Number, String], default: 0 },
    note: { type: String, default: '' },
    copiesToCommlog: { type: Boolean, default: false },
  },
  data() {
    seq += 1;
    return { uid: `fu-drphone-${seq}` };
  },
  methods: {
    onStatus(v) {
      const n = Number(v);
      this.$emit('status-change', Number.isFinite(n) ? n : 0);
    },
  },
};
</script>

<style lang="scss" scoped>
@import './drawer';

.fu-drform { display: flex; flex-direction: column; gap: 16px; }
.fu-drform__label { @include fu-dr-field-label; }
.fu-drform__select { @include fu-input; }
.fu-drform__textarea { @include fu-dr-textarea; }
.fu-drform__hint { @include fu-dr-hint; }

.fu-drform__hint--copy {
  display: flex;
  align-items: center;
  gap: 6px;
  .fu-icon { flex: none; color: $fu-success; }
}

.fu-dr--phone .fu-drform__select,
.fu-dr--phone .fu-drform__textarea { @include fu-dr-phone-input; }
</style>
